import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  rowStyle: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-start',
    gap: '24px',
  },
  items: {
    width: '918px',
  },
  textStyle: {
    color: '#6A777A',
    fontSize: '12px',
  },
}))
